/* =====================================================================
 * DropOverlay — 파일 드래그 시 표시되는 공통 오버레이
 * WorkspaceShell (에이전트 등) 및 StoragePage에서 동일 스타일로 사용
 * ===================================================================== */

import React from 'react';
import styled, { keyframes } from 'styled-components';
import { FileUp } from 'lucide-react';

interface Props {
  label?: string;
}

export const DropOverlay: React.FC<Props> = ({
  label = '파일을 여기에 놓으세요',
}) => (
  <Overlay>
    <IconCircle>
      <FileUp size={36} strokeWidth={1.5} color="currentColor" />
    </IconCircle>
    <Label>{label}</Label>
  </Overlay>
);

/* ---- Animations ---- */

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const iconFloat = keyframes`
  0%, 100% { transform: translateY(0); }
  50%      { transform: translateY(-6px); }
`;

/* ---- Styled ---- */

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 50;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  animation: ${fadeIn} 0.2s ease;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  background: ${({ theme }) =>
    theme.mode === 'dark'
      ? 'rgba(23, 23, 23, 0.82)'
      : 'rgba(255, 255, 255, 0.82)'};
  pointer-events: none;
`;

const IconCircle = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) =>
    theme.mode === 'dark'
      ? 'rgba(255, 255, 255, 0.07)'
      : 'rgba(0, 0, 0, 0.04)'};
  color: ${({ theme }) => theme.colors.textSecondary};
  animation: ${iconFloat} 2s ease-in-out infinite;
`;

const Label = styled.span`
  font-size: 1rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textSecondary};
  letter-spacing: -0.01em;
`;
